import { Media } from "./media.model";

export enum SizeChartTypes {
    image = "image",
    tool = "tool",
}

export class SizeChart {
    type: SizeChartTypes;
    image: Media;

    constructor(
        image : Media,
        type: SizeChartTypes = SizeChartTypes.image,
    ) {
        this.image = image;
        this.type = type;
    }
}